import { TGetSystemSettingDto } from "@/api/services/admin/system-setting/dtos/get-system-setting.dto";
import { TUpdateEmailSettingReqDto } from "@/api/services/admin/system-setting/dtos/update-email-setting.dto";
import { TUpdateMaintenanceSettingReqDto } from "@/api/services/admin/system-setting/dtos/update-maintenance-setting.dto";
import { TMaintenanceForm } from "@/features/system-settings/types/maintenanceForm";
import { TSettingForm } from "@/features/system-settings/types/settingForm";
import { dayjs } from "@/utils/dayjs";

export const convertEmailSettingFormToUpdateReq = (data: TSettingForm): TUpdateEmailSettingReqDto => ({
  ...data,
});

export const convertEmailSettingResToForm = (data: TGetSystemSettingDto): Partial<TSettingForm> => ({
  irohanaSystemNotificationEmail: data.irohanaSystemNotificationEmail ?? undefined,
  clientSystemNotificationEmail: data.clientSystemNotificationEmail ?? undefined,
});

export const convertMaintenanceSettingResToForm = (data: TGetSystemSettingDto): Partial<TMaintenanceForm> => ({
  maintenanceMode: data.maintenanceMode ?? "",
  modeStartDateTime: data.modeStartDateTime ? dayjs(data.modeStartDateTime) : null,
  modeEndDateTime: data.modeEndDateTime ? dayjs(data.modeEndDateTime) : null,
  maintenanceMessage: data.maintenanceMessage ?? null,
});

export const convertMaintenanceSettingFormToUpdateReq = (data: TMaintenanceForm): TUpdateMaintenanceSettingReqDto => ({
  maintenanceMode: data.maintenanceMode,
  modeStartDateTime: data.modeStartDateTime ? dayjs.tz(data.modeStartDateTime.format("YYYY-MM-DDTHH:mm:ss"), "Asia/Tokyo").toISOString() : null,
  modeEndDateTime: data.modeEndDateTime ? dayjs.tz(data.modeEndDateTime.format("YYYY-MM-DDTHH:mm:ss"), "Asia/Tokyo").toISOString() : null,
  maintenanceMessage: data.maintenanceMessage ? data.maintenanceMessage : null,
});
